












import Vue from 'vue'
import numeral from 'numeral'

import BaseInputRange from '../Base/InputRange.vue'

import types from '../../store/types'

export default Vue.extend({
  components: {
    BaseInputRange
  },

  computed: {
    value(): number {
      return this.$store.state.Current.scale
    },
    displayValue(): string {
      return numeral(this.$store.state.Current.scale).format('0.00')
    }
  },

  methods: {
    updateValue(e: Event): void {
      if (! e.target) {
        return
      }
      const tgt: HTMLInputElement = e.target as HTMLInputElement
      this.$store.commit(types.mutations.CURRENT_SCALE, tgt.value)
    }
  }
})
